/**
 * General chat naming + key contract (city vs venue).
 *
 * Chat key (sent as place_id to join/get group APIs):
 *   1. Prefer check-in payload place_id (Google place_id for venue OR city geocode).
 *   2. If missing (city check-in without place_id): `city:{normalized_city_name}`.
 *
 * Display name:
 *   venue → `{place_name}`
 *   city  → `{city} Hang` (or "Hang nearby" if city missing)
 */
export function getGeneralChatName(checkInData) {
  if (!checkInData) return 'Hang nearby';
  const type = checkInData.checkInType || checkInData.location?.type;
  const placeName =
    checkInData.place_name ||
    checkInData.location?.name ||
    '';
  const city =
    checkInData.location?.city ||
    (type === 'city' ? placeName : '') ||
    '';

  if (type === 'venue') {
    return placeName || 'Hang nearby';
  }
  // city (or unknown treated as city-level)
  if (city) return `${city} Hang`;
  if (placeName) return `${placeName} Hang`;
  return 'Hang nearby';
}

export function getGeneralChatKey(checkInData) {
  if (!checkInData) return null;
  const placeId = checkInData.place_id || checkInData.location?.place_id;
  if (placeId && placeId !== 'current') {
    return placeId;
  }
  const type = checkInData.checkInType || checkInData.location?.type;
  const city =
    checkInData.location?.city ||
    (type === 'city'
      ? checkInData.place_name || checkInData.location?.name
      : null);
  if (city) {
    return `city:${String(city).trim().toLowerCase()}`;
  }
  return null;
}

export default getGeneralChatName;
